import type { Site } from './site.interface';

export interface cv_SiteType {
    Abbreviation: string;
    C_SiteType_key: number;
    C_VocabularySource_key: number | null;
    C_Workgroup_key: number;
    CreatedBy: string;
    DateCreated: Date;
    DateModified: Date;
    ElementID: string;
    IsActive: boolean;
    IsDefault: boolean;
    IsDeprecated: boolean;
    ModifiedBy: string;
    Site: Site[];
    SiteType: string;
    SortOrder: number | null;
    Version: number;
}
